import React, { useContext } from 'react';
import { string, bool } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ComponentPlaceholder } from '@thd-olt-component-react/loading-placeholder';

const FBRPlaceholder = ({ color, showLoadingAnimation }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  return (
    <ComponentPlaceholder
      height={isMobile ? 350 : 500}
      rows={10}
      color={color}
      showLoadingAnimation={showLoadingAnimation}
    />
  );
};

FBRPlaceholder.propTypes = {
  color: string,
  showLoadingAnimation: bool
};

FBRPlaceholder.defaultProps = {
  color: '#E0E0E0',
  showLoadingAnimation: false
};

export { FBRPlaceholder };
